import { getTranslation } from '../providers/TranslationProvider';

const CAPTCHA = 1026;
const FORBIDDEN = 403;
const LOCK_OUT = 429;
const RATE_LIMIT = 998;
const UNAUTHORIZED = 419;
const serverErrorKeyMap = {
  em_address: 'email',
  mobile_number: 'phone',
};

const loginError = () => getTranslation({
  translationKey: 'errors.parse.login',
  fallback: "We couldn't validate your login information. Please check that your email and password are correct.",
});

export default (errorObj, isUserErrorFlagEnabled = false) => {
  if (errorObj.status === UNAUTHORIZED) {
    return {
      keys: ['password', 'email'],
      msg: loginError(),
      errorStatus: errorObj.status,
    };
  }

  if (errorObj.status === LOCK_OUT) {
    return {
      keys: ['password', 'email'],
      msg: errorObj.message || loginError(),
      errorStatus: errorObj.status,
    };
  }

  if (errorObj && errorObj.status === FORBIDDEN && errorObj.code === RATE_LIMIT) { // rate limit
    return {
      keys: [],
      msg: errorObj.message || '',
      errorStatus: errorObj.status,
    };
  }

  if (errorObj && errorObj.status === 400 && errorObj?.data?.code && isUserErrorFlagEnabled) {
    return {
      keys: [],
      msg: errorObj?.data?.code || '',
      errorStatus: errorObj.status,
    };
  }

  if (errorObj && errorObj.status === FORBIDDEN && errorObj.code === CAPTCHA) {
    return {
      keys: [],
      msg: getTranslation({ translationKey: 'errors.parse.captcha', fallback: 'Please complete the captcha so we know you are not a robot.' }),
      errorStatus: errorObj.status,
    };
  }

  const data = errorObj.data || {};

  const keys = Object.keys(data).map((key) => (
    serverErrorKeyMap[key] || key
  ));

  return {
    keys,
    data,
    errorStatus: errorObj.status,
  };
};
